import { RootStore } from ".";
import { observable, action } from "mobx";

export class PrintStore {

    _rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
    }

    @observable formName = "";
    @observable data: any = {};

    @action
    drawForm(formName: string, data: any) {
        this.formName = formName;
        this.data = data;
    }
}